export { default } from './price-list.view';
